import {TaskContent} from "@/views/happs/core/lib/CoreData";

export class PlanningTaskData {

    constructor(id = null, content = {}) {
        this.id = id;
        this.content = content;
    }
}
